import {ChangeDetectorRef, OnDestroy, Pipe, PipeTransform} from "@angular/core";
import {AppSettingsService} from "./app-settings.service";
import {Subscription} from "rxjs/Subscription";
import {AppSettingsModel} from "./app-settings.model";

@Pipe({
  name: "appSetting",
  pure: false,
})
export class AppSettingPipe implements PipeTransform, OnDestroy {
  subscription: Subscription;
  settings: AppSettingsModel = new AppSettingsModel();

  lastValue: string;
  lastResult: string;

  processResult(value: string, result: string): string {
    this.lastValue = value;
    this.lastResult = result;
    return result;
  }

  transform(value: string): string {
    if (value === undefined || value === null || value === "") return value;
    if (value === this.lastValue) return this.lastResult;

    let transformed = this.settings[value];

    if (transformed === null || transformed === undefined) {
      transformed = "";
    }

    if (typeof transformed !== "string") {
      transformed = `${transformed}`;
    }

    return this.processResult(value, transformed);
  }

  ngOnDestroy() {
    if (this.subscription && !this.subscription.closed) {
      this.subscription.unsubscribe();
    }

    this.lastValue = undefined;
    this.lastResult = undefined;
    this.subscription = undefined;
  }

  constructor(
    private appSettingsService: AppSettingsService,
    private ref: ChangeDetectorRef,
  ) {
    this.subscription = this.appSettingsService.settings.subscribe((settings: AppSettingsModel) => {
      this.settings = settings;
      this.lastValue = undefined;
      this.ref.markForCheck();
    });
  }
}
